import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {observable} from "mobx";
import {SectionOptionsEnum} from "InternalShared/PageBuilder/Services/DragDropService";


export abstract class PDFControlBaseOptions extends StoreBase {
    @observable
    Id: number;
    Type: string;
    @observable
    TargetId: SectionOptionsEnum;
    @observable
    Styles: PDFControlBaseStyles;
    @observable
    Expandable: boolean;
    @observable
    DesignerHeight: number;
    HideFromTemplateDesigner:boolean;
    TemplateFieldName:string;
    Lock:boolean;
    DesignerWidth: number;

    protected LoadDefaultValues() {
        this.Lock=false;
        this.Id = 0;
        this.Type = '';
        this.TargetId = SectionOptionsEnum.header;
        this.Styles = new PDFControlBaseStyles().Merge();
        this.Expandable = false;
        this.DesignerHeight = 0;
        this.DesignerWidth=0;
        this.TemplateFieldName='';
        this.HideFromTemplateDesigner=false;
    }
}

export class PDFControlBaseStyles extends StoreBase {
    @observable
    Top: string;
    @observable
    Left: string;
    @observable
    @StoreDataType(String)
    Width: string;
    @observable
    @StoreDataType(String)
    Height: string;
    @observable
    ZIndex: number;

    protected LoadDefaultValues() {
        this.Top = "";
        this.Left = "";
        this.Width = '';
        this.Height = '';
        this.ZIndex = 1;
    }
}

